import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import AppHub from '../ui/pages/hub/view';
import Planes from '../ui/pages/planes/view';
import Pos from '../ui/pages/pos/view';
import Compras from '../ui/pages/compras/view';
import Invoice from '../ui/pages/invoice/view';
import ProductsHub from '../ui/pages/products/view';
import ServicesPage from '../ui/pages/services/view';
import GeneralLayout from '../ui/templates/view';
import Accounting from '../ui/pages/accounting';
import AccountsManagement from '../ui/pages/AccountsManagement';
import RedirectQrInvoice from '../ui/organisms/qRedirectr/view';
import ProfilePage from '../ui/pages/profile/view';
import TercerosCRM from '../ui/pages/terceros-crm';
import OperationsPage from '../ui/pages/operations/view';


export class SuperAdmin {
    getRoutes() {
        return (
            <Router>
                <Routes>
                    <Route path="/operations" element={<GeneralLayout child={<OperationsPage />} />} />
                    <Route path="/accounts-management" element={<GeneralLayout child={<AccountsManagement />} />} />
                    <Route path="/redirect" element={<GeneralLayout child={<RedirectQrInvoice />} />} />
                    <Route path="/accounting" element={<GeneralLayout child={<Accounting />} />} />
                    <Route path="/invoice" element={<GeneralLayout child={<Invoice />} />} />
                    <Route path="/stock" element={<GeneralLayout child={<ProductsHub />} />} />
                    <Route path="/services" element={<GeneralLayout child={<ServicesPage />} />} />
                    <Route path="/compras" element={<GeneralLayout child={<Compras />} />} />
                    <Route path="/pos" element={<GeneralLayout child={<Pos />} />} />
                    <Route path="/planes" element={<GeneralLayout child={<Planes />} />} />
                    <Route path="/profile" element={<GeneralLayout child={<ProfilePage />} />} />
                    <Route path="/terceros" element={<GeneralLayout child={<TercerosCRM />} />} />
                    <Route path="/hub" element={<GeneralLayout child={<AppHub />} />} />
                    <Route path="/" element={<GeneralLayout child={<AppHub />} />} />
                    <Route path="*" element={<GeneralLayout child={<AppHub />} />} />
                </Routes>
            </Router>
        )
    }

}
